import React from 'react';
import CV from "../../assets/cv.pdf";

export const CTA = () => {
  const handleDownloadAndOpen = (e) => {
    e.preventDefault(); // Prevent the default navigation
    // Open the CV in a new tab
    const newTab = window.open(CV, "_blank");
    // Create a temporary link for downloading the CV
    const link = document.createElement("a");
    link.href = CV;
    link.download = "krishankumarsafi.pdf"; // Suggest a filename for the download
    document.body.appendChild(link);
    link.click(); // Trigger the download
    document.body.removeChild(link); // Clean up the temporary link
    if (newTab) newTab.focus(); // Bring the new tab to the foreground
  };

  return (
    <div className='cta'>
      <a
        href={CV}
        target="_blank"
        rel="noopener noreferrer"
        className='btn'
        onClick={handleDownloadAndOpen}
      >
        Download CV
      </a>
      <a href="#contact" className='btn btn-primary'>
        Let's Talk
      </a>
    </div>
  );
};
